import { RxTemplate } from './rx-template.model';
import { deepFreeze, deepMerge } from './rx-template-utils';
import { defaultTemplate } from './default.template';
import { glidewellTemplate } from './glidewell.template';
import { labBrokerDefaultTemplate } from './lab-broker-default.template';

export const TEMPLATE_REGISTRY: Record<string, Readonly<RxTemplate>> = {
	glidewell: deepFreeze(deepMerge(defaultTemplate, glidewellTemplate as RxTemplate)),
	labBrokerDefault: deepFreeze(deepMerge(defaultTemplate, labBrokerDefaultTemplate as RxTemplate))
};

export const DEFAULT_TEMPLATE: Readonly<RxTemplate> = deepFreeze(defaultTemplate);
